module.exports = __webpack_public_path__ + "img/curret_right_black.9861dd61.svg";